import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Product from './Product'
import FreeAlignmentCheckBlock from './FreeAlignmentCheckBlock'
import InstallationKits from './InstallationKits'

const ProductTable = ({
  products = [],
  installationKits = [],
  freeAligmentTooltip,
  freeAlignmentCheckDisabled,
  otdPricingToolTipMessage,
  inActiveSkuMessage,
  enableEdit
}) =>
  <Fragment>
    <TransitionGroup>
      {
        products.map((product = {}, index) =>
          <CSSTransition
            key={ product.skuId || index }
            timeout={ 1000 }
            classNames="product-item">
            <Product
              key={ product.skuId || index }
              index={ index }
              product={ product }
              first={ !index }
              inActiveSkuMessage={ inActiveSkuMessage }
              otdPricingToolTipMessage={ otdPricingToolTipMessage }
              enableEdit={ enableEdit } />
          </CSSTransition>
        )
      }
    </TransitionGroup>
    {
      Boolean(installationKits.length) &&
        <InstallationKits installationKits={ installationKits } />
    }
    {
      Boolean(products.length) && enableEdit && !freeAlignmentCheckDisabled &&
      <FreeAlignmentCheckBlock freeAligmentTooltip={ freeAligmentTooltip } />
    }
  </Fragment>

ProductTable.propTypes = {
  enableEdit: PropTypes.bool,
  freeAligmentTooltip: PropTypes.shape(),
  freeAlignmentCheckDisabled: PropTypes.bool,
  inActiveSkuMessage: PropTypes.string,
  installationKits: PropTypes.arrayOf(PropTypes.shape()),
  otdPricingToolTipMessage: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape())
}

export default ProductTable
